import { PersonaDashboard } from "../components/radix-components/PersonaDashboard";
import { StarfieldLayout } from "../components/radix-components/StarfieldLayout";

export function PersonaPage() {
    return (
        <StarfieldLayout>
            <PersonaDashboard />
        </StarfieldLayout>
    );
}
